import { useCallback, useMemo, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import UICheckbox from 'UIComponents/input/UICheckbox';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import useFetchSubscriptions from 'asset-actions-lib-forms/editNonHSMailchimpList/hooks/useFetchSubscriptions';
import useUpdateSubscriptions from 'asset-actions-lib-forms/editNonHSMailchimpList/hooks/useUpdateSubscriptions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ESPSettingsDialog({
  crmObject,
  onClose
}) {
  const [subscriptionState, setSubscriptionState] = useState([]);
  const formGuid = getPropertyValue(crmObject, 'hs_form_id') || '';
  const {
    data,
    loading
  } = useFetchSubscriptions(formGuid);
  const {
    updateSubscriptions
  } = useUpdateSubscriptions();
  const isDisabled = useMemo(() => loading || data.length === 0, [data.length, loading]);
  const handleSave = useCallback(() => {
    if (subscriptionState.length === 0) {
      onClose();
    } else {
      updateSubscriptions({
        formGuid,
        subscriptions: subscriptionState
      }).then(onClose).catch(() => {});
    }
  }, [formGuid, onClose, subscriptionState, updateSubscriptions]);
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "esp-settings-dialog",
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: onClose
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.header"
        })
      })
    }), loading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      minHeight: 80,
      layout: "centered"
    }) : /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormControl, {
        label: data.length === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.body.noLists"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.body.lists"
        }),
        children: /*#__PURE__*/_jsx(ToggleGroup, {
          name: "subscriptions",
          children: data.map(({
            espListId,
            name,
            syncEnabled
          }) => /*#__PURE__*/_jsx(UICheckbox, {
            defaultChecked: syncEnabled,
            onChange: event => {
              setSubscriptionState(data.map(sub => {
                if (sub.espListId === espListId) {
                  return Object.assign({}, sub, {
                    syncEnabled: event.target.checked
                  });
                }
                return sub;
              }));
            },
            children: name
          }, espListId))
        })
      })
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(Button, {
        disabled: isDisabled,
        onClick: handleSave,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.editMailchimpLists.save"
        })
      })
    })]
  });
}